import type { Modifier, StrictModifiers } from "@popperjs/core";
import { useCallback, useState } from "react";

export const useArrowModifiers = () => {
  const [arrowModifier, setArrowModifier] = useState<Partial<Modifier<string, object>>>({
    enabled: false,
    name: "arrow",
  });

  const captureArrowElementReference = useCallback(
    (element: HTMLDivElement | null) => {
      const arrowModifier: StrictModifiers = {
        enabled: !!element,
        name: "arrow",
        options: {
          element,
        },
      };

      setArrowModifier(arrowModifier);
    },
    [setArrowModifier],
  );

  return { arrowModifier, captureArrowElementReference };
};
